import { CreateCodeTableFetchMixin } from "../../../vue-ocom/mixins";
export default {
  mixins: [CreateCodeTableFetchMixin(["CodeTaskType"])],
  computed: {
    title() {
      const task_type_id = this.$route.params.task_type_id;
      return (
        "Manage " +
        this.optionCodeTaskTypeItemsById[task_type_id].description +
        " Jobs"
      );
    },
  },
};
